import React, { Component } from "react";
import SectionLoader from "../SectionLoader";
import { withRouter } from "react-router-dom";
import { withApollo } from "react-apollo";
import {
    Form,
    Button,
    TextArea,
    Input,
    Label,
    Loader,
    Message,
    Icon,
    Popup,
    Grid,
    Header,
    Dropdown,
    Progress
} from "semantic-ui-react";
import { GET_SECTION_IV } from "../../../../queries/SectionQueries";
import {
    GET_SECTION_1,
    SUBMIT_SECTION_1,
    UPDATE_SECTION_1,
    GET_EDIT_SECTION_SUBMISSION,
    GET_ALL_EDIT_SUBMMISSIONS
} from "../../../../queries/SubmissionQueries";

import { USER_NAME } from "../../../../constants/index";

import { uploadFile, deleteFile } from "../../../../firebase/FileServices";
import { Promise } from "q";
import { setFormStatus, setSuccessStatus } from '../../../../actions/user-actions';
import { connect } from 'react-redux';
import sectionFourQuestions from '../../../questions/section4_questions.json';
import { withNamespaces } from "react-i18next";

const mapStateToProps = (state, ownProps) => {
    return {
        formErrorStatus: state.custom_reducer.formErrorStatus,
        formSuccessState: state.custom_reducer.formSuccessState,
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        setFormStatus: (status) => {
            dispatch(setFormStatus(status))
        },
        setSuccessStatus: (status) => {
            dispatch(setSuccessStatus(status))
        }
    }
}
const trainingOptions = [
    {
        key: "Internal",
        text: "Internal",
        value: "Internal"
    },
    {
        key: "External",
        text: "External",
        value: "External"
    },
    {
        key: "Both the above",
        text: "Both the above",
        value: "Both the above"
    }
]

const systemTypeOptions = [
    { key: "Internally developed", value: "Internally developed", text: "Internally developed" },
    { key: "Readymade software​", value: "Readymade software", text: "Readymade software" }
]
class ViewSection5 extends Component {
    constructor(props) {
        super(props);

        this.props.setFormStatus({ status: false, title: '', message: '' });
        this.props.setSuccessStatus({ status: false, title: '', message: '' });
        // const proObj = this.props.location.pathname.split('/');
        this.state = {
            submissionId: this.props.location.state.submissionId,
            submissionType: this.props.location.state.submissionType,
            userId: localStorage.USER_ID,
            loading: true,
            spinner: false,
            saveNContinue: false,
            sectionEmpty: true,
            section: {
                id: "",
                sectionNumber: "",
                title: "",
                subTitle: "",
                description: "",
                sequence: "",
                createdAt: "",
                updatedAt: ""
            },
            // question1: {
            //     showFollowupQuestion: false,
            //     primaryQuestion:
            //         "Does your organization own any buildings?",
            //     primaryAnswer: false,
            //     secondaryQuestion: "If Yes, list out, including the value.",
            //     secondaryAnswer: "",
            //     secondaryJson: {},
            //     secondaryArray: [{ buildingName: "", value: "" }],
            //     weightFactor: "0.1",
            //     uploads: [],
            //     validated: true,
            //     isScore: false,
            //     feedBack: "",
            //     score: "",
            // },
            // question2: {
            //     showFollowupQuestion: false,
            //     primaryQuestion:
            //         "Does your organization own any vehicles?",
            //     primaryAnswer: false,
            //     secondaryQuestion: "If Yes, list out the types, including the value.",
            //     secondaryAnswer: "",
            //     secondaryJson: {},
            //     secondaryArray: [{ vehicleType: "", value: "" }],
            //     weightFactor: "0.3",
            //     uploads: [],
            //     validated: true,
            //     isScore: false,
            //     feedBack: "",
            //     score: "",
            // },
            // question3: {
            //     showFollowupQuestion: false,
            //     primaryQuestion:
            //         "Does your organization own any land? ",
            //     primaryAnswer: false,
            //     secondaryQuestion: "If Yes, list out, including the value.",
            //     secondaryAnswer: "",
            //     secondaryJson: {},
            //     secondaryArray: [{ landLocation: "", landSize: "", value: "" }],
            //     weightFactor: "0.1",
            //     uploads: [],
            //     validated: true,
            //     isScore: false,
            //     feedBack: "",
            //     score: "",
            // },
            // question4: {
            //     showFollowupQuestion: true,
            //     primaryQuestion: "What other assets, facilities and equipment does your organization own?",
            //     primaryAnswer: "",
            //     secondaryQuestion: "",
            //     q4secondaryAnswer: "",
            //     uploads: [],
            //     fileUrl: null,
            //     fileRef: null,
            //     tempFile: "",
            //     weightFactor: "-0.1",
            //     isUploading: false,
            //     validated: false,
            //     isScore: true,
            //     feedBack: "",
            //     score: "",
            // },
            // question5: {
            //     showFollowupQuestion: false,
            //     primaryQuestion:
            //         "Can your organization mortgage any of the properties mentioned above to obtain a credit facility?",
            //     primaryAnswer: false,
            //     secondaryQuestion:
            //         "If Yes, which properties can be mortgaged.",
            //     secondaryAnswer: "",
            //     weightFactor: "0.3",
            //     uploads: [],
            //     validated: true,
            //     isScore: false,
            //     feedBack: "",
            //     score: "",
            // },
            // question6: {
            //     showFollowupQuestion: true,
            //     primaryQuestion:
            //         "Where does your organization conduct its training activities?",
            //     primaryAnswer: "",
            //     secondaryQuestion: "",
            //     secondaryAnswer: "",
            //     secondaryJson: {},
            //     weightFactor: "-0.1",
            //     uploads: [],
            //     validated: false,
            //     isScore: true,
            //     feedBack: "",
            //     score: "",
            // },
            // question7: {
            //     showFollowupQuestion: true,
            //     primaryQuestion:
            //         "What data management system(s) does your organization use to collate service statistics?",
            //     primaryAnswer: "",
            //     secondaryQuestion: "",
            //     secondaryAnswer: "",
            //     weightFactor: "-0.1",
            //     uploads: [],
            //     validated: false,
            //     isScore: true,
            //     feedBack: "",
            //     score: "",
            // },
            // question8: {
            //     showFollowupQuestion: true,
            //     primaryQuestion:
            //         "How does your organization use the data collated from the data management system?",
            //     primaryAnswer: "",
            //     secondaryQuestion: "",
            //     secondaryAnswer: "",
            //     weightFactor: "-0.1",
            //     uploads: [],
            //     validated: false,
            //     isScore: true,
            //     feedBack: "",
            //     score: "",
            // },
            // question9: {
            //     showFollowupQuestion: true,
            //     primaryQuestion:
            //         "What enterprise resource planning (ERP) systems does your organization use for Finance, HR, other supporting functions, etc.?",
            //     primaryAnswer: "",
            //     secondaryQuestion: "",
            //     secondaryAnswer: "",
            //     primaryArray: [{ systemOrSoftwareName: "", department: "" }],
            //     primaryJson: {},
            //     weightFactor: "-0.1",
            //     uploads: [],
            //     validated: false,
            //     isScore: true,
            //     feedBack: "",
            //     score: "",
            // },
            ...sectionFourQuestions,
            sectionFeedBack: "",
            validation_arr: [],
            progress: 0
        };
        props.setFormStatus({ status: false, title: "", message: "" });
        props.setSuccessStatus({ status: false, title: "", message: "" });
        this._getSection3();
        this._getSection3Submissions();

        this._question1Onchange = this._question1Onchange.bind(this);
        this._question2Onchange = this._question2Onchange.bind(this);
        this._question3Onchange = this._question3Onchange.bind(this);
        this.get_all_submissions().then(submission => {
            submission.map(item => {
                Object.keys(item.submission).map(key => {
                    if (item.submission[key]['validated'] !== undefined && item.submission[key]['validated'] === true) {
                        this.state.validation_arr.push(item.submission[key]['validated']);
                    }
                })
            });
            console.log(this.state.validation_arr)
            const percent_progress = parseFloat((this.state.validation_arr.length / 48) * 100).toFixed(0)
            this.setState({
                progress: percent_progress
            });
        });

    }
    get_all_submissions = async () => {
        const { submissionId, submissionType } = this.state;
        console.log(submissionId)
        const result = await this.props.client.query({
            query: GET_ALL_EDIT_SUBMMISSIONS,
            variables: { submissionId: submissionId },
            fetchPolicy: 'network-only'
        });
        return result.data.getAllEditSubmissionsByUser;
    };
    componentDidMount() {
        window.scrollTo(0, 0)
        setTimeout(() => {
            this.setState({
                loading: false
            });
        }, 2000);
    }
    _goBack = () => {
        const { submissionId, submissionType } = this.state;
        this.props.history.push({ pathname: `/assessment/view/section4`, state: { submissionId: submissionId, submissionType: submissionType } });
    };

    _next = () => {
        const { submissionId, submissionType } = this.state;
        this.props.history.push({ pathname: `/assessment/view/section6`, state: { submissionId: submissionId, submissionType: submissionType } });
    };

    _getSection3 = () => {
        this.props.client
            .query({
                query: GET_SECTION_IV
            })
            .then(result => {
                this.setState({
                    section: { ...result.data.getSection1 }
                });
            })
            .catch(error => {
                console.log(error);
            });
    };

    _getSection3Submissions = () => {
        const { submissionId, submissionType } = this.state;
        this.props.client
            .query({
                query: GET_EDIT_SECTION_SUBMISSION,
                variables: { sectionId: "ck1gmw55c1ko10b88d4v0x3yi", submissionId: submissionId },
                fetchPolicy: 'network-only'
            })
            .then(result => {
                console.log(result);
                if (result.data.getEditSectionSubmission === null || result.data.getEditSectionSubmission.length === 0) {
                    console.log('there is nothing here');

                } else {
                    // Apply values 
                    this.setState({
                        question1: result.data.getEditSectionSubmission.submission.question1
                            ? { ...result.data.getEditSectionSubmission.submission.question1, weightFactor: this.state.question1.weightFactor }
                            : this.state.question1,
                        question2: result.data.getEditSectionSubmission.submission.question2
                            ? { ...result.data.getEditSectionSubmission.submission.question2, weightFactor: this.state.question2.weightFactor }
                            : this.state.question2,
                        question3: result.data.getEditSectionSubmission.submission.question3
                            ? { ...result.data.getEditSectionSubmission.submission.question3, weightFactor: this.state.question3.weightFactor }
                            : this.state.question3,
                        question4: result.data.getEditSectionSubmission.submission.question4
                            ? { ...result.data.getEditSectionSubmission.submission.question4, weightFactor: this.state.question4.weightFactor }
                            : this.state.question4,
                        question5: result.data.getEditSectionSubmission.submission.question5
                            ? { ...result.data.getEditSectionSubmission.submission.question5, weightFactor: this.state.question5.weightFactor }
                            : this.state.question5,
                        question6: result.data.getEditSectionSubmission.submission.question6
                            ? { ...result.data.getEditSectionSubmission.submission.question6, weightFactor: this.state.question6.weightFactor }
                            : this.state.question6,
                        question7: result.data.getEditSectionSubmission.submission.question7
                            ? { ...result.data.getEditSectionSubmission.submission.question7, weightFactor: this.state.question7.weightFactor }
                            : this.state.question7,
                        question8: result.data.getEditSectionSubmission.submission.question8
                            ? { ...result.data.getEditSectionSubmission.submission.question8, weightFactor: this.state.question8.weightFactor }
                            : this.state.question8,
                        question9: result.data.getEditSectionSubmission.submission.question9
                            ? { ...result.data.getEditSectionSubmission.submission.question9, weightFactor: this.state.question9.weightFactor }
                            : this.state.question9,
                        sectionFeedBack: result.data.getEditSectionSubmission.submission.sectionFeedBack ? result.data.getEditSectionSubmission.submission.sectionFeedBack : this.state.sectionFeedBack,
                        sectionEmpty: false
                    });
                }
            })
            .catch(error => {
                console.log(error);
            });
    };

    // Question1 Stuff
    _question1Followup = state => {
        let fields = this.state.question1.secondaryArray;
        const toArray = fields.reduce((acc, obj) => [...acc, Object.values(obj).map(y => y.trim())], []);
        const singleArr = [].concat(...toArray);
        const emptyStrings = singleArr.filter(str => str.trim().length <= 0);

        state
            ? this.setState({
                question1: {
                    ...this.state.question1,
                    showFollowupQuestion: true,
                    primaryAnswer: true,
                    validated: emptyStrings.length === 0 ? true : false
                }
            })
            : this.setState({
                question1: {
                    ...this.state.question1,
                    showFollowupQuestion: false,
                    primaryAnswer: false,
                    validated: true
                }
            });
    };

    _question1Onchange = event => {
        this.setState({
            question1: {
                ...this.state.question1,
                secondaryJson: {
                    ...this.state.question1.secondaryJson,
                    [event.target.id]: event.target.value
                }
            }
        });
    };

    // Question 2 stuff
    _question2Followup = state => {
        let fields = this.state.question2.secondaryArray;
        const toArray = fields.reduce((acc, obj) => [...acc, Object.values(obj).map(y => y.trim())], []);
        const singleArr = [].concat(...toArray);
        const emptyStrings = singleArr.filter(str => str.trim().length <= 0);
        state
            ? this.setState({
                question2: {
                    ...this.state.question2,
                    showFollowupQuestion: true,
                    primaryAnswer: true,
                    validated: emptyStrings.length === 0 ? true : false
                }
            })
            : this.setState({
                question2: {
                    ...this.state.question2,
                    showFollowupQuestion: false,
                    primaryAnswer: false,
                    validated: true
                }
            });
    };

    _question2Onchange = event => {
        this.setState({
            question2: {
                ...this.state.question2,
                secondaryJson: {
                    ...this.state.question2.secondaryJson,
                    [event.target.id]: event.target.value
                }
            }
        });
    };

    // Question 3 stuff
    _question3Followup = state => {
        let fields = this.state.question3.secondaryArray;
        const toArray = fields.reduce((acc, obj) => [...acc, Object.values(obj).map(y => y.trim())], []);
        const singleArr = [].concat(...toArray);
        const emptyStrings = singleArr.filter(str => str.trim().length <= 0);
        state
            ? this.setState({
                question3: {
                    ...this.state.question3,
                    showFollowupQuestion: true,
                    primaryAnswer: true,
                    validated: emptyStrings.length === 0 ? true : false
                }
            })
            : this.setState({
                question3: {
                    ...this.state.question3,
                    showFollowupQuestion: false,
                    primaryAnswer: false,
                    validated: true
                }
            });
    };

    _question3Onchange = event => {
        this.setState({
            question3: {
                ...this.state.question3,
                secondaryJson: {
                    ...this.state.question3.secondaryJson,
                    [event.target.id]: event.target.value
                }
            }
        });
    };

    //Question 4 stuff
    _question4Followup = state => {
        state
            ? this.setState({
                question4: {
                    ...this.state.question4,
                    showFollowupQuestion: true,
                    primaryAnswer: true
                }
            })
            : this.setState({
                question4: {
                    ...this.state.question4,
                    showFollowupQuestion: false,
                    primaryAnswer: false
                }
            });
    };

    _question4Onchange = event => {
        this.setState({
            question4: {
                ...this.state.question4,
                [event.target.id]: event.target.value,
                validated: event.target.value.trim() === "" ? false : true
            }
        });
    };

    // Question 5 stuff
    _question5Followup = state => {
        state
            ? this.setState({
                question5: {
                    ...this.state.question5,
                    showFollowupQuestion: true,
                    primaryAnswer: true,
                    validated: this.state.question5.secondaryAnswer.trim() === "" ? false : true
                }
            })
            : this.setState({
                question5: {
                    ...this.state.question5,
                    showFollowupQuestion: false,
                    primaryAnswer: false,
                    validated: true
                }
            });
    };

    _question5Onchange = event => {
        this.setState({
            question5: {
                ...this.state.question5,
                [event.target.id]: event.target.value,
                validated: event.target.value.trim() === "" ? false : true
            }
        });
    };

    _question6Onchange = event => {
        this.setState({
            question6: {
                ...this.state.question6,
                [event.target.id]: event.target.value
            }
        });
    };

    //Question 7 Stuff
    _question7Onchange = event => {
        this.setState({
            question7: {
                ...this.state.question7,
                [event.target.id]: event.target.value,
                validated: event.target.value.trim() === "" ? false : true
            }
        });
    };

    // Question 8 stuff
    _question8Onchange = event => {
        this.setState({
            question8: {
                ...this.state.question8,
                [event.target.id]: event.target.value,
                validated: event.target.value.trim() === "" ? false : true
            }
        });
    };

    // Question 9 stuff
    _question9Followup = state => {
        state
            ? this.setState({
                question9: {
                    ...this.state.question9,
                    showFollowupQuestion: false,
                    primaryAnswer: true
                }
            })
            : this.setState({
                question9: {
                    ...this.state.question9,
                    showFollowupQuestion: false,
                    primaryAnswer: false
                }
            });
    };

    // _question9Onchange = event => {
    //   this.setState({
    //     question9: {
    //       ...this.state.question9,
    //       [event.target.id]: event.target.value
    //     }
    //   });
    // };

    _question9Onchange = event => {
        this.setState({
            question9: {
                ...this.state.question9,
                primaryJson: {
                    ...this.state.question9.primaryJson,
                    [event.target.id]: event.target.value
                }
            }
        });
    };

    isEmpty(obj) {
        for (var key in obj) {
            if (obj.hasOwnProperty(key))
                return false;
        }
        return true;
    }

    _handleMultiChange31(i, e) {
        if (e.target.value < 0) {
            e.preventDefault();
        } else {
            const { name, value } = e.target;
            let fields = this.state.question1.secondaryArray;
            fields[i][name] = value;

            const toArray = fields.reduce((acc, obj) => [...acc, Object.values(obj).map(y => y.trim())], []);
            const singleArr = [].concat(...toArray);
            const emptyStrings = singleArr.filter(str => str.trim().length <= 0);

            this.setState({
                question1: {
                    ...this.state.question1,
                    validated: emptyStrings.length === 0 ? true : false
                }
            });

            this.setState({ fields });
        }

    }

    _handleMultiChange32(i, e) {
        if (e.target.value < 0) {
            e.preventDefault();
        } else {
            const { name, value } = e.target;
            let fields = this.state.question2.secondaryArray;
            fields[i][name] = value;

            const toArray = fields.reduce((acc, obj) => [...acc, Object.values(obj).map(y => y.trim())], []);
            const singleArr = [].concat(...toArray);
            const emptyStrings = singleArr.filter(str => str.trim().length <= 0);

            this.setState({
                question2: {
                    ...this.state.question2,
                    validated: emptyStrings.length === 0 ? true : false
                }
            });
            this.setState({ fields });
        }
    }

    _handleMultiChange33(i, e) {
        if (e.target.value < 0) {
            e.preventDefault();
        } else {
            const { name, value } = e.target;
            let fields = this.state.question3.secondaryArray;
            fields[i][name] = value;

            const toArray = fields.reduce((acc, obj) => [...acc, Object.values(obj).map(y => y.trim())], []);
            const singleArr = [].concat(...toArray);
            const emptyStrings = singleArr.filter(str => str.trim().length <= 0);

            this.setState({
                question3: {
                    ...this.state.question3,
                    validated: emptyStrings.length === 0 ? true : false
                }
            });
            this.setState({ fields });
        }
    }

    _handleMultiChange39(i, e) {
        const { name, value } = e.target;
        let fields = this.state.question9.primaryArray;
        fields[i][name] = value;
        const toArray = fields.reduce((acc, obj) => [...acc, Object.values(obj).map(y => y.trim())], []);
        const singleArr = [].concat(...toArray);
        const emptyStrings = singleArr.filter(str => str.trim().length <= 0);

        this.setState({
            question9: {
                ...this.state.question9,
                validated: emptyStrings.length === 0 ? true : false
            }
        });
        this.setState({ fields });
    }

    _addMoreClick31() {
        let fields = this.state.question1.secondaryArray;
        fields.push({ buildingName: "", value: "" });
        this.setState({
            question1: {
                ...this.state.question1,
                validated: false
            }
        });
        this.setState(fields)
    }

    _addMoreClick32() {
        let fields = this.state.question2.secondaryArray;
        fields.push({ vehicleType: "", value: "" });
        this.setState({
            question2: {
                ...this.state.question2,
                validated: false
            }
        });
        this.setState(fields)
    }

    _addMoreClick33() {
        let fields = this.state.question3.secondaryArray;
        fields.push({ landLocation: "", landSize: "", value: "" });
        this.setState({
            question3: {
                ...this.state.question3,
                validated: false
            }
        });
        this.setState(fields)
    }

    _addMoreClick39() {
        let fields = this.state.question9.primaryArray;
        fields.push({ systemOrSoftwareName: "", department: "" });
        this.setState({
            question9: {
                ...this.state.question9,
                validated: false
            }
        });
        this.setState(fields)
    }

    _remoevMoreClick31(i) {
        let secondaryArray = this.state.question1.secondaryArray;
        secondaryArray.splice(i, 1);

        const toArray = secondaryArray.reduce((acc, obj) => [...acc, Object.values(obj).map(y => y.trim())], []);
        const singleArr = [].concat(...toArray);
        const emptyStrings = singleArr.filter(str => str.trim().length <= 0);

        this.setState({
            question1: {
                ...this.state.question1,
                validated: emptyStrings.length === 0 ? true : false
            }
        });

        this.setState({ secondaryArray });
    }

    _remoevMoreClick32(i) {
        let secondaryArray = this.state.question2.secondaryArray;
        secondaryArray.splice(i, 1);

        const toArray = secondaryArray.reduce((acc, obj) => [...acc, Object.values(obj).map(y => y.trim())], []);
        const singleArr = [].concat(...toArray);
        const emptyStrings = singleArr.filter(str => str.trim().length <= 0);

        this.setState({
            question2: {
                ...this.state.question2,
                validated: emptyStrings.length === 0 ? true : false
            }
        });

        this.setState({ secondaryArray });
    }

    _remoevMoreClick33(i) {
        let secondaryArray = this.state.question3.secondaryArray;
        secondaryArray.splice(i, 1);

        const toArray = secondaryArray.reduce((acc, obj) => [...acc, Object.values(obj).map(y => y.trim())], []);
        const singleArr = [].concat(...toArray);
        const emptyStrings = singleArr.filter(str => str.trim().length <= 0);

        this.setState({
            question3: {
                ...this.state.question3,
                validated: emptyStrings.length === 0 ? true : false
            }
        });

        this.setState({ secondaryArray });
    }

    _remoevMoreClick39(i) {
        let primaryArray = this.state.question9.primaryArray;
        primaryArray.splice(i, 1);

        const toArray = primaryArray.reduce((acc, obj) => [...acc, Object.values(obj).map(y => y.trim())], []);
        const singleArr = [].concat(...toArray);
        const emptyStrings = singleArr.filter(str => str.trim().length <= 0);

        this.setState({
            question9: {
                ...this.state.question9,
                validated: emptyStrings.length === 0 ? true : false
            }
        });

        this.setState({ primaryArray });
    }

    _createMulipleQ31() {
        const { t, i18n } = this.props;
        if (this.state.question1.secondaryArray != undefined) {
            return this.state.question1.secondaryArray.map((el, i) => (
                <div key={i}>
                    <br />

                    <div className="uk-grid">
                        <div className="uk-width-1-2">
                            <label>{t("Building Name")}</label> <br />
                            {/* <input
                                id="buildingName"
                                type="text"
                                name="buildingName"
                                placeholder={t("Building Name")}
                                value={el.buildingName || ''}
                                onChange={this._handleMultiChange31.bind(this, i)}
                                disabled
                            /> */}
                            <TextArea
                                onChange={this._handleMultiChange31.bind(this, i)}
                                name="buildingName"
                                id="buildingName"
                                value={el.buildingName || ''}
                                placeholder={t("Building Name")}
                                type="text"
                                readOnly
                                rows={1}
                            />

                        </div>

                        <div className="uk-width-1-2">
                            <label>{t("Value")}</label> <br />
                            <Input
                                labelPosition={localStorage.RAT_LANG == 'ar' ? "left" : "right"}
                                type="number"
                                placeholder={t("Value")}
                                id="value"
                                name="value"
                                style={{ width: "60%" }}
                                value={el.value || ''}
                                onChange={this._handleMultiChange31.bind(this, i)}
                                disabled
                                onKeyDown={e => {
                                    if (/[\+\-\.\,]/.test(e.key) || e.key.toUpperCase() === "E") {
                                        e.preventDefault();
                                    }
                                }}
                            >
                                <Label basic>$</Label>
                                <input />
                                <Label>.00</Label>
                            </Input>
                        </div>

                    </div>
                    <br />

                    {this.state.question1.secondaryArray.length <= 1 ? (
                        null
                    ) : (
                        null
                        // <div className="ms-Grid-col ms-sm6 ms-lg2 uk-text-right">
                        //     <i class="fas fa-trash-alt multiple_Field_Remove" aria-hidden="true" onClick={this._remoevMoreClick31.bind(this, i)}></i>                                
                        // </div>
                    )}

                    < hr className="multiple_Field_Seperator" />

                </div >

            ))
        } else {
            let fields = this.state.question1;
            fields["secondaryArray"] = [{ buildingName: "", value: "" }];
            this.setState(fields)
        }
    }

    _createMulipleQ32() {
        const { t, i18n } = this.props;
        if (this.state.question2.secondaryArray != undefined) {
            return this.state.question2.secondaryArray.map((el, i) => (
                <div key={i}>
                    <br />

                    <div className="uk-grid">
                        <div className="uk-width-1-2">
                            <label>{t("Vehicle Type")}</label>
                            {/* <input
                                value={el.vehicleType || ''}
                                onChange={this._handleMultiChange32.bind(this, i)}
                                id="vehicleType"
                                name="vehicleType"
                                placeholder={t("Vehicle Type")}
                                disabled
                            /> */}
                            <TextArea
                                onChange={this._handleMultiChange32.bind(this, i)}
                                name="vehicleType"
                                id="vehicleType"
                                value={el.vehicleType || ''}
                                placeholder={t("Vehicle Type")}
                                type="text"
                                readOnly
                                rows={1}
                            />
                        </div>

                        <div className="uk-width-1-2">
                            <label>{t("Value")}</label> <br />
                            <Input
                                labelPosition={localStorage.RAT_LANG == 'ar' ? "left" : "right"}
                                type="number"
                                placeholder={t("Value")}
                                id="value"
                                name="value"
                                style={{ width: "60%" }}
                                value={el.value || ''}
                                onChange={this._handleMultiChange32.bind(this, i)}
                                disabled
                                onKeyDown={e => {
                                    if (/[\+\-\.\,]/.test(e.key) || e.key.toUpperCase() === "E") {
                                        e.preventDefault();
                                    }
                                }}
                            >
                                <Label basic>$</Label>
                                <input />
                                <Label>.00</Label>
                            </Input>
                        </div>

                    </div>
                    <br />

                    {this.state.question2.secondaryArray.length <= 1 ? (
                        null
                    ) : (
                        null
                        // <div className="ms-Grid-col ms-sm6 ms-lg2 uk-text-right">
                        //     <i class="fas fa-trash-alt multiple_Field_Remove" aria-hidden="true" onClick={this._remoevMoreClick32.bind(this, i)}></i>                               
                        // </div>
                    )}
                    < hr className="multiple_Field_Seperator" />
                </div >

            ))
        } else {
            let fields = this.state.question2;
            fields["secondaryArray"] = [{ vehicleType: "", value: "" }];
            this.setState(fields)
        }
    }

    _createMulipleQ33() {
        const { t, i18n } = this.props;
        if (this.state.question3.secondaryArray != undefined) {
            return this.state.question3.secondaryArray.map((el, i) => (
                <div key={i}>
                    <br />

                    <div className="uk-grid">
                        <div className="uk-width-1-3">
                            <label>{t("Land location (city/town)")}</label>
                            {/* <input
                                value={el.landLocation || ''}
                                onChange={this._handleMultiChange33.bind(this, i)}
                                id="landLocation"
                                name="landLocation"
                                placeholder={t("Land Location")}
                                disabled
                            /> */}
                            <TextArea
                                onChange={this._handleMultiChange33.bind(this, i)}
                                name="landLocation"
                                id="landLocation"
                                // style={{marginTop: "21px"}}
                                className={localStorage.RAT_LANG == 'en' ? "land_loca_other" : localStorage.RAT_LANG == 'sp' ? "land_loca_other" : localStorage.RAT_LANG == 'ar' ? "land_loca_other" : ""}
                                value={el.landLocation || ''}
                                placeholder={t("Land Location")}
                                type="text"
                                readOnly
                                rows={1}
                            />
                        </div>

                        <div className="uk-width-1-3">
                            <label>{t("Land size (in Square meters)")}</label>
                            <input
                                value={el.landSize || ''}
                                onChange={this._handleMultiChange33.bind(this, i)}
                                // style={{ marginTop: "21px", fontSize:"14px" }}
                                className={localStorage.RAT_LANG=='sp'? "input_sp_placeholder":"input__other_placeholder"}
                                disabled
                                id="landSize"
                                name="landSize"
                                placeholder={t("1 sq meter = 0.0001 hectare")}
                                type="number"
                                onKeyDown={e => {
                                    if (/[\+\-\.\,]/.test(e.key) || e.key.toUpperCase() === "E") {
                                        e.preventDefault();
                                    }
                                }}
                            />
                        </div>

                        <div className="uk-width-1-3" >
                            <label>{t("Value")}</label> <br />
                            <Input
                                size='mini'
                                labelPosition={localStorage.RAT_LANG == 'ar' ? "left" : "right"}
                                type="number"
                                placeholder={t("Value")}
                                id="value"
                                name="value"
                                className={localStorage.RAT_LANG == 'sp' ? "input_field_sp" : "input_field_other"}
                                // style={{ width: "50%",marginTop: "25px" }}
                                value={el.value || ''}
                                onChange={this._handleMultiChange33.bind(this, i)}
                                disabled
                                onKeyDown={e => {
                                    if (/[\+\-\.\,]/.test(e.key) || e.key.toUpperCase() === "E") {
                                        e.preventDefault();
                                    }
                                }}
                            >
                                <Label basic>$</Label>
                                <input />
                                <Label>.00</Label>
                            </Input>
                        </div>

                    </div>
                    <br />

                    {this.state.question3.secondaryArray.length <= 1 ? (
                        null
                    ) : (
                        null
                        // <div className="ms-Grid-col ms-sm6 ms-lg2 uk-text-right">
                        //     <i class="fas fa-trash-alt multiple_Field_Remove" aria-hidden="true" onClick={this._remoevMoreClick33.bind(this, i)}></i>                               
                        // </div>
                    )}
                    < hr className="multiple_Field_Seperator" />
                </div >

            ))
        } else {
            let fields = this.state.question3;
            fields["secondaryArray"] = [{ landLocation: "", landSize: "", value: "" }];
            this.setState(fields)
        }
    }

    _createMulipleQ39() {
        const { t, i18n } = this.props;
        if (this.state.question9.primaryArray != undefined) {
            return this.state.question9.primaryArray.map((el, i) => (
                <div key={i}>
                    <br />

                    <div className="uk-grid">
                        <div className="uk-width-1-2">
                            <label>{t("System/Software name (SAGE, SAP HR, etc.)")}</label>
                            {/* <input
                                value={el.systemOrSoftwareName || ''}
                                onChange={this._handleMultiChange39.bind(this, i)}
                                id="systemOrSoftwareName"
                                name="systemOrSoftwareName"
                                placeholder={t("System/Software name (SAGE, SAP HR, etc.)")}
                                disabled
                            /> */}
                            <TextArea
                                onChange={this._handleMultiChange39.bind(this, i)}
                                name="systemOrSoftwareName"
                                id="systemOrSoftwareName"
                                value={el.systemOrSoftwareName || ''}
                                placeholder={t("System/Software name (SAGE, SAP HR, etc.)")}
                                type="text"
                                readOnly
                            />

                        </div>

                        <div className="uk-width-1-2">
                            <label>{t("Department (Finance, HR, etc.)")}</label>
                            {/* <input
                                value={el.department || ''}
                                onChange={this._handleMultiChange39.bind(this, i)}
                                id="department"
                                name="department"
                                placeholder={t("Department (Finance, HR, etc.)")}
                                disabled
                            /> */}
                            <TextArea
                                onChange={this._handleMultiChange39.bind(this, i)}
                                name="department"
                                id="department"
                                value={el.department || ''}
                                placeholder={t("Department (Finance, HR, etc.)")}
                                type="text"
                                readOnly
                            />
                        </div>

                    </div>
                    <br />

                    {this.state.question9.primaryArray.length <= 1 ? (
                        null
                    ) : (
                        null
                        // <div className="ms-Grid-col ms-sm6 ms-lg2 uk-text-right">
                        //     <i class="fas fa-trash-alt multiple_Field_Remove" aria-hidden="true" onClick={this._remoevMoreClick39.bind(this, i)}></i>                               
                        // </div>
                    )}
                    < hr className="multiple_Field_Seperator" />
                </div >

            ))
        } else {
            let fields = this.state.question9;
            fields["primaryArray"] = [{ systemOrSoftwareName: "", department: "" }];
            this.setState(fields)

        }
    }
    _question1Onchange = event => {
        this.setState({
            question1: {
                ...this.state.question1,
                [event.target.id]: event.target.value
            }
        });
    };

    _question1jsonOnchange = (event, data) => {
        this.setState({
            question6: {
                ...this.state.question6,
                [data.id]: data.value,
                validated: data.value === "" ? false : true
            }
        });

        // this.setState({
        //   question6: {
        //     ...this.state.question6,
        //     secondaryJson: {
        //       ...this.state.question6.secondaryJson,
        //       [data.id]: data.value
        //     }
        //   }
        // });
    };

    _pagi = (path) => {
        const { submissionId, submissionType } = this.state;
        this.props.history.push({ pathname: "/assessment/view/".concat(path), state: { submissionId: submissionId, submissionType: submissionType } });
    }
    render() {
        const { formErrorStatus, formSuccessState, t, i18n } = this.props;
        const { progress } = this.state
        return (
            <div class="remove-disabled">
                {this.state.loading ? (
                    <SectionLoader />
                ) : (
                    <div>
                        {/* Begin Dark Header */}
                        <div className="uk-section-default uk-section">
                            <div className="uk-container-small uk-margin-auto uk-margin-medium-top">
                                <h3 className=" uk-text-light">
                                    {" "}
                                    {t("Section")} {this.state.section.sectionNumber}{" "}
                                    {/* {this.state.section.title}{" "} */}
                                </h3>
                            </div>
                            <hr />

                            <div
                                className="uk-container-small uk-margin-auto uk-margin-small-top uk-padding-small paper-read"
                                uk-scrollspy="target: > .paper; cls:uk-animation-slide-bottom-small; delay: 200"
                            >
                                <div className="paper uk-link-reset " style={{ backgroundColor: "#151F6D" }}>
                                    <div className="uk-grid uk-flex-middle">
                                        <div className="uk-width-1-6 uk-flex-first uk-text-center">
                                            <i className="far fa-comment-alt icon-xxlarge"></i>
                                        </div>
                                        <div className="uk-width-5-6">
                                            <h4 className="uk-margin-remove" style={{ color: "#ffffff" }}>
                                                {" "}
                                                {t(this.state.section.title)}{" "}
                                            </h4>
                                            {/* <p className="uk-margin-remove">
                          {" "}
                          {this.state.section.description}{" "}
                        </p> */}
                                        </div>
                                    </div>
                                </div>
                                <Progress style={{ margin: 0 }} percent={progress} progress indicating size='medium' />
                                <Form success error className="uk-margin">
                                    {/* Begin Question 1 */}
                                    <div className="uk-link-reset paper uk-margin s1q1">
                                        <h4>
                                            <b>27)</b>{" "}
                                            {t("Does your organization own any buildings?")}{" "}
                                        </h4>
                                        {localStorage.RAT_LANG == 'ar' ? (
                                            <Button.Group size="large" className="buttons_arabic_style" >
                                                
                                               
                                                <Button disabled positive={this.state.question1.showFollowupQuestion ? false : true} onClick={() => this._question1Followup(false)}>
                                                    {t("NO")}
                                                </Button>
                                                {/* <Button.Or /> */}
                                                <div class="or" data-text={localStorage.RAT_LANG=='sp'? "o" : localStorage.RAT_LANG=='fr'? "ou" : localStorage.RAT_LANG=='ar'? "أو": "or"}></div>
                                                <Button disabled positive={this.state.question1.showFollowupQuestion ? true : false} onClick={() => this._question1Followup(true)}>
                                                    {t("YES")}
                                                </Button>
                                            </Button.Group>
                                        ) : (
                                            <Button.Group size="large" >
                                                <Button disabled positive={this.state.question1.showFollowupQuestion ? true : false} onClick={() => this._question1Followup(true)}>
                                                    {t("YES")}
                                                </Button>
                                                {/* <Button.Or /> */}
                                                <div class="or" data-text={localStorage.RAT_LANG=='sp'? "o" : localStorage.RAT_LANG=='fr'? "ou" : localStorage.RAT_LANG=='ar'? "أو": "or"}></div>
                                                <Button disabled positive={this.state.question1.showFollowupQuestion ? false : true} onClick={() => this._question1Followup(false)}>
                                                    {t("NO")}
                                                </Button>
                                            </Button.Group>
                                        )}

                                        {this.state.question1.showFollowupQuestion ? (
                                            <div>
                                                <div className="uk-form-label">
                                                    {t("If Yes, list out, including the value.")}
                                                </div>
                                                <div >

                                                    {this._createMulipleQ31()}
                                                    <div className="uk-text-right"><button disabled onClick={this._addMoreClick31.bind(this)} className="uk-button uk-button-big uk-button-primary multiple_Field_Plus" type="button">{t("Add One More")}</button></div>

                                                </div>
                                            </div>
                                        ) : (
                                            ""
                                        )}

                                        {/* {this.state.question1.score && this.state.question1.score !== "" ? (
                                                <p><span style={{ color: "#eaaa00", fontWeight: "bold" }}>Score given: </span> <span className="uk-text-muted">{this.state.question1.score}</span></p>
                                            ) : (
                                                    ""
                                                )} */}
                                        {this.state.question1.feedBack && this.state.question1.feedBack !== "" ? (
                                            <p><span style={{ color: "#eaaa00", fontWeight: "bold" }}>{t("Comments/Feedback from SE Hub")}:</span> <div className="uk-text-muted" dangerouslySetInnerHTML={{ __html: this.state.question1.feedBack.replace(/(?:\r\n|\r|\n)/g, '<br />') }}></div> </p>
                                        ) : (
                                            ""
                                        )}
                                    </div>
                                    {/* End Question 1 */}


                                    {/* Begin Question2 */}
                                    <div className="uk-link-reset paper uk-margin s1q1">
                                        <h4>
                                            <b>28)</b>{" "}
                                            {t("Does your organization own any vehicles?")}{" "}
                                        </h4>
                                        {localStorage.RAT_LANG=='ar'? (
                                             <Button.Group size="large" className="buttons_arabic_style" >
                                             <Button disabled positive={this.state.question2.showFollowupQuestion ? false : true} onClick={() => this._question2Followup(false)}>
                                                 {t("NO")}
                                             </Button>
                                             {/* <Button.Or /> */}
                                             <div class="or" data-text={localStorage.RAT_LANG=='sp'? "o" : localStorage.RAT_LANG=='fr'? "ou" : localStorage.RAT_LANG=='ar'? "أو": "or"}></div>
                                             <Button disabled positive={this.state.question2.showFollowupQuestion ? true : false} onClick={() => this._question2Followup(true)}>
                                                 {t("YES")}
                                             </Button>
                                         </Button.Group>
                                        ):(
                                            <Button.Group size="large"  >
                                            <Button disabled positive={this.state.question2.showFollowupQuestion ? true : false} onClick={() => this._question2Followup(true)}>
                                                {t("YES")}
                                            </Button>
                                            {/* <Button.Or /> */}
                                            <div class="or" data-text={localStorage.RAT_LANG=='sp'? "o" : localStorage.RAT_LANG=='fr'? "ou" : localStorage.RAT_LANG=='ar'? "أو": "or"}></div>
                                            <Button disabled positive={this.state.question2.showFollowupQuestion ? false : true} onClick={() => this._question2Followup(false)}>
                                                {t("NO")}
                                            </Button>
                                        </Button.Group>
                                        )}
                                       
                                        {this.state.question2.showFollowupQuestion ? (
                                            <div>
                                                <div className="uk-form-label">
                                                    {t("If Yes, list out the types, including the value.")}
                                                </div>
                                                <div>
                                                    {this._createMulipleQ32()}
                                                    <div className="uk-text-right"><button disabled onClick={this._addMoreClick32.bind(this)} className="uk-button uk-button-big uk-button-primary multiple_Field_Plus" type="button">{t("Add One More")}</button></div>
                                                </div>

                                            </div>
                                        ) : (
                                            ""
                                        )}
                                        {/* {this.state.question2.score && this.state.question2.score !== "" ? (
                                                <p><span style={{ color: "#eaaa00", fontWeight: "bold" }}>Score given: </span> <span className="uk-text-muted">{this.state.question2.score}</span></p>
                                            ) : (
                                                    ""
                                                )} */}
                                        {this.state.question2.feedBack && this.state.question2.feedBack !== "" ? (
                                            <p><span style={{ color: "#eaaa00", fontWeight: "bold" }}>{t("Comments/Feedback from SE Hub")}:</span> <div className="uk-text-muted" dangerouslySetInnerHTML={{ __html: this.state.question2.feedBack.replace(/(?:\r\n|\r|\n)/g, '<br />') }}></div> </p>
                                        ) : (
                                            ""
                                        )}
                                    </div>
                                    {/* End Question 2 */}

                                    {/* Begin Question 3 */}

                                    <div className="uk-link-reset paper uk-margin s1q1">
                                        <h4>
                                            <b>29)</b>{" "}
                                            {t("Does your organization own any land?")}{" "}
                                        </h4>
                                        {localStorage.RAT_LANG=='ar'? (
                                             <Button.Group size="large" className="buttons_arabic_style" >
                                            
                                             
                                             <Button disabled positive={this.state.question3.showFollowupQuestion ? false : true} onClick={() => this._question3Followup(false)}>
                                                 {t("NO")}
                                             </Button>
                                             {/* <Button.Or /> */}
                                             <div class="or" data-text={localStorage.RAT_LANG=='sp'? "o" : localStorage.RAT_LANG=='fr'? "ou" : localStorage.RAT_LANG=='ar'? "أو": "or"}></div>
                                             <Button disabled positive={this.state.question3.showFollowupQuestion ? true : false} onClick={() => this._question3Followup(true)}>
                                                 {t("YES")}
                                             </Button>
                                         </Button.Group>
                                        ):(
                                            <Button.Group size="large" >
                                            <Button disabled positive={this.state.question3.showFollowupQuestion ? true : false} onClick={() => this._question3Followup(true)}>
                                                {t("YES")}
                                            </Button>
                                            {/* <Button.Or /> */}
                                            <div class="or" data-text={localStorage.RAT_LANG=='sp'? "o" : localStorage.RAT_LANG=='fr'? "ou" : localStorage.RAT_LANG=='ar'? "أو": "or"}></div>
                                            <Button disabled positive={this.state.question3.showFollowupQuestion ? false : true} onClick={() => this._question3Followup(false)}>
                                                {t("NO")}
                                            </Button>
                                        </Button.Group>
                                        )}
                                       
                                        {this.state.question3.showFollowupQuestion ? (
                                            <div>
                                                <div className="uk-form-label">
                                                    {t("If Yes, list out, including the value.")}
                                                </div>
                                                <div>
                                                    {this._createMulipleQ33()}
                                                    <div className="uk-text-right"><button disabled onClick={this._addMoreClick33.bind(this)} className="uk-button uk-button-big uk-button-primary multiple_Field_Plus" type="button">{t("Add One More")}</button></div>
                                                </div>
                                            </div>
                                        ) : (
                                            ""
                                        )}
                                        {/* {this.state.question3.score && this.state.question3.score !== "" ? (
                                                <p><span style={{ color: "#eaaa00", fontWeight: "bold" }}>Score given: </span> <span className="uk-text-muted">{this.state.question3.score}</span></p>
                                            ) : (
                                                    ""
                                                )} */}
                                        {this.state.question3.feedBack && this.state.question3.feedBack !== "" ? (
                                            <p><span style={{ color: "#eaaa00", fontWeight: "bold" }}>{t("Comments/Feedback from SE Hub")}:</span> <div className="uk-text-muted" dangerouslySetInnerHTML={{ __html: this.state.question3.feedBack.replace(/(?:\r\n|\r|\n)/g, '<br />') }}></div> </p>
                                        ) : (
                                            ""
                                        )}
                                    </div>

                                    {/* End Question 3 */}

                                    {/* Begin Question 4 */}
                                    <div className="uk-link-reset paper uk-margin s1q1">
                                        <h4 style={{ fontSize: "1.20rem" }}><b>30)</b> {t("What other assets, facilities and equipment does your organization own?")} </h4>
                                        <p class="uk-text-muted uk-margin-remove-top uk-margin-small-bottom">{t("Please answer and provide details.")}</p>

                                        <TextArea
                                            onChange={this._question4Onchange}
                                            name="primaryAnswer"
                                            id="primaryAnswer"
                                            value={this.state.question4.primaryAnswer}
                                            className="text-area-height uk-input uk-form-width-large"
                                            placeholder={t("Describe here")}
                                            type="text"
                                            disabled
                                        />
                                        {/* {this.state.question4.score && this.state.question4.score !== "" ? (
                                                <p><span style={{ color: "#eaaa00", fontWeight: "bold" }}>Score given: </span> <span className="uk-text-muted">{this.state.question4.score}</span></p>
                                            ) : (
                                                    ""
                                                )} */}
                                        {this.state.question4.feedBack && this.state.question4.feedBack !== "" ? (
                                            <p><span style={{ color: "#eaaa00", fontWeight: "bold" }}>{t("Comments/Feedback from SE Hub")}:</span> <div className="uk-text-muted" dangerouslySetInnerHTML={{ __html: this.state.question4.feedBack.replace(/(?:\r\n|\r|\n)/g, '<br />') }}></div> </p>
                                        ) : (
                                            ""
                                        )}

                                    </div>
                                    {/* End Question 4 */}

                                    {/* Begin Question 5 */}
                                    <div className="uk-link-reset paper uk-margin s1q1">
                                        <h4>
                                            <b>31)</b>{" "}
                                            {t("Can your organization mortgage any of the properties mentioned above to obtain a credit facility?")}{" "}
                                        </h4>
                                        {localStorage.RAT_LANG=='ar'? (
                                             <Button.Group size="large" className="buttons_arabic_style" >
                                             
                                            
                                             <Button disabled positive={this.state.question5.showFollowupQuestion ? false : true} onClick={() => this._question5Followup(false)}>
                                                 {t("NO")}
                                             </Button>
                                             {/* <Button.Or /> */}
                                             <div class="or" data-text={localStorage.RAT_LANG=='sp'? "o" : localStorage.RAT_LANG=='fr'? "ou" : localStorage.RAT_LANG=='ar'? "أو": "or"}></div>
                                             <Button disabled positive={this.state.question5.showFollowupQuestion ? true : false} onClick={() => this._question5Followup(true)}>
                                                 {t("YES")}
                                             </Button>
                                         </Button.Group>
                                        ):(
                                            <Button.Group size="large">
                                            <Button disabled positive={this.state.question5.showFollowupQuestion ? true : false} onClick={() => this._question5Followup(true)}>
                                                {t("YES")}
                                            </Button>
                                            {/* <Button.Or /> */}
                                            <div class="or" data-text={localStorage.RAT_LANG=='sp'? "o" : localStorage.RAT_LANG=='fr'? "ou" : localStorage.RAT_LANG=='ar'? "أو": "or"}></div>
                                            <Button disabled positive={this.state.question5.showFollowupQuestion ? false : true} onClick={() => this._question5Followup(false)}>
                                                {t("NO")}
                                            </Button>
                                        </Button.Group>
                                        )}
                                       
                                        {this.state.question5.showFollowupQuestion ? (
                                            <div>
                                                <div className="uk-form-label">
                                                    {t("If Yes, which properties can be mortgaged.")}
                                                </div>
                                                <div className="uk-margin">
                                                    <span className="uk-form-icon">
                                                        <i className="far fa-User icon-medium"></i>
                                                    </span>

                                                    <TextArea
                                                        onChange={this._question5Onchange}
                                                        name="secondaryAnswer"
                                                        id="secondaryAnswer"
                                                        value={this.state.question5.secondaryAnswer}
                                                        className="text-area-height uk-input uk-form-width-large"
                                                        placeholder={t("Describe here")}
                                                        type="text"
                                                        disabled
                                                    />

                                                </div>
                                            </div>
                                        ) : (
                                            null
                                        )}

                                        {/* {this.state.question5.score && this.state.question5.score !== "" ? (
                                                <p><span style={{ color: "#eaaa00", fontWeight: "bold" }}>Score given: </span> <span className="uk-text-muted">{this.state.question5.score}</span></p>
                                            ) : (
                                                    ""
                                                )} */}
                                        {this.state.question5.feedBack && this.state.question5.feedBack !== "" ? (
                                            <p><span style={{ color: "#eaaa00", fontWeight: "bold" }}>{t("Comments/Feedback from SE Hub")}:</span> <div className="uk-text-muted" dangerouslySetInnerHTML={{ __html: this.state.question5.feedBack.replace(/(?:\r\n|\r|\n)/g, '<br />') }}></div> </p>
                                        ) : (
                                            ""
                                        )}
                                    </div>
                                    {/* End Question 5 */}

                                    {/* Begin Question 6 */}
                                    <div className="uk-link-reset paper uk-margin s1q1">
                                        <h4>
                                            <b>32)</b>{" "}
                                            {t("Where does your organization conduct its training activities?")}{" "}
                                        </h4>
                                        {/* <p class="uk-text-muted uk-margin-remove-top uk-margin-small-bottom">Please answer and support the response with additional details.</p> */}

                                        <div className="uk-form-label">
                                            {t("Training Activities")}{"  :  "}
                                            {" "}
                                            <Dropdown
                                                style={{ marginLeft: "10px" }}
                                                onChange={this._question1jsonOnchange}
                                                name="primaryAnswer"
                                                id="primaryAnswer"
                                                selection
                                                value={this.isEmpty(this.state.question6.primaryAnswer) ? (
                                                    null
                                                ) : (
                                                    this.state.question6.primaryAnswer
                                                )}
                                                placeholder={t("Select location")}
                                                options={[
                                                    {
                                                        key: "Internal",
                                                        text:  t("Internal"),
                                                        value: t("Internal")
                                                    },
                                                    {
                                                        key: "External",
                                                        text: t("External"),
                                                        value: t("External")
                                                    },
                                                    {
                                                        key: "Both the above",
                                                        text: t("Both the above"),
                                                        value: t("Both the above")
                                                    }
                                                ]}
                                                disabled
                                            />
                                        </div>

                                        {/* {this.state.question6.score && this.state.question6.score !== "" ? (
                                                <p><span style={{ color: "#eaaa00", fontWeight: "bold" }}>Score given: </span> <span className="uk-text-muted">{this.state.question6.score}</span></p>
                                            ) : (
                                                    ""
                                                )} */}
                                        {this.state.question6.feedBack && this.state.question6.feedBack !== "" ? (
                                            <p><span style={{ color: "#eaaa00", fontWeight: "bold" }}>{t("Comments/Feedback from SE Hub")}:</span> <div className="uk-text-muted" dangerouslySetInnerHTML={{ __html: this.state.question6.feedBack.replace(/(?:\r\n|\r|\n)/g, '<br />') }}></div> </p>
                                        ) : (
                                            ""
                                        )}

                                    </div>


                                    {/* End Question 6 */}

                                    {/* Begin Question 7 */}
                                    <div className="uk-link-reset paper uk-margin s1q1">
                                        <h4>
                                            <b>33)</b>{" "}
                                            {t("What data management system(s) does your organization use to collate service statistics?")}{" "}
                                        </h4>
                                        <p class="uk-text-muted uk-margin-remove-top uk-margin-small-bottom">{t("Please answer and support the response with additional details.")}</p>
                                        <div>
                                            <div className="uk-form-label"></div>
                                            <div className="uk-margin">
                                                <span className="uk-form-icon">
                                                    <i className="far fa-User icon-medium"></i>
                                                </span>

                                                <TextArea
                                                    onChange={this._question7Onchange}
                                                    name="primaryAnswer"
                                                    id="primaryAnswer"
                                                    value={this.state.question7.primaryAnswer}
                                                    className="text-area-height uk-input uk-form-width-large"
                                                    placeholder={t("Describe here")}
                                                    type="text"
                                                    disabled
                                                />
                                            </div>
                                        </div>
                                        {/* {this.state.question7.score && this.state.question7.score !== "" ? (
                                                <p><span style={{ color: "#eaaa00", fontWeight: "bold" }}>Score given: </span> <span className="uk-text-muted">{this.state.question7.score}</span></p>
                                            ) : (
                                                    ""
                                                )} */}
                                        {this.state.question7.feedBack && this.state.question7.feedBack !== "" ? (
                                            <p><span style={{ color: "#eaaa00", fontWeight: "bold" }}>{t("Comments/Feedback from SE Hub")}:</span> <div className="uk-text-muted" dangerouslySetInnerHTML={{ __html: this.state.question7.feedBack.replace(/(?:\r\n|\r|\n)/g, '<br />') }}></div> </p>
                                        ) : (
                                            ""
                                        )}
                                    </div>
                                    {/* End Question 7 */}

                                    {/* Begin Question 8 */}
                                    <div className="uk-link-reset paper uk-margin s1q1">
                                        <h4>
                                            <b>34)</b>{" "}
                                            {t("How does your organization use the data collated from the data management system?")}{" "}
                                        </h4>
                                        <p class="uk-text-muted uk-margin-remove-top uk-margin-small-bottom">{t("Please answer and support the response with additional details.")}</p>
                                        <div>
                                            <div className="uk-form-label"></div>
                                            <div className="uk-margin">
                                                <span className="uk-form-icon">
                                                    <i className="far fa-User icon-medium"></i>
                                                </span>

                                                <TextArea
                                                    onChange={this._question8Onchange}
                                                    name="primaryAnswer"
                                                    id="primaryAnswer"
                                                    value={this.state.question8.primaryAnswer}
                                                    className="text-area-height uk-input uk-form-width-large"
                                                    placeholder={t("Describe here")}
                                                    type="text"
                                                    disabled
                                                />
                                            </div>
                                        </div>
                                        {/* {this.state.question8.score && this.state.question8.score !== "" ? (
                                                <p><span style={{ color: "#eaaa00", fontWeight: "bold" }}>Score given: </span> <span className="uk-text-muted">{this.state.question8.score}</span></p>
                                            ) : (
                                                    ""
                                                )} */}
                                        {this.state.question8.feedBack && this.state.question8.feedBack !== "" ? (
                                            <p><span style={{ color: "#eaaa00", fontWeight: "bold" }}>{t("Comments/Feedback from SE Hub")}:</span> <div className="uk-text-muted" dangerouslySetInnerHTML={{ __html: this.state.question8.feedBack.replace(/(?:\r\n|\r|\n)/g, '<br />') }}></div> </p>
                                        ) : (
                                            ""
                                        )}
                                    </div>
                                    {/* End Question 8 */}

                                    {/* Begin Question 9 */}
                                    <div className="uk-link-reset paper uk-margin s1q1">
                                        <h4>
                                            <b>35)</b>{" "}
                                            {t("What enterprise resource planning (ERP) systems does your organization use for Finance, HR, other supporting functions, etc.?")}{" "}
                                        </h4>
                                        <div>
                                            <div>
                                                {this._createMulipleQ39()}
                                                <div className="uk-text-right"><button disabled onClick={this._addMoreClick39.bind(this)} className="uk-button uk-button-big uk-button-primary multiple_Field_Plus" type="button">{t("Add One More")}</button></div>
                                            </div>
                                        </div>
                                        {/* {this.state.question9.score && this.state.question9.score !== "" ? (
                                                <p><span style={{ color: "#eaaa00", fontWeight: "bold" }}>Score given: </span> <span className="uk-text-muted">{this.state.question9.score}</span></p>
                                            ) : (
                                                    ""
                                                )} */}
                                        {this.state.question9.feedBack && this.state.question9.feedBack !== "" ? (
                                            <p><span style={{ color: "#eaaa00", fontWeight: "bold" }}>{t("Comments/Feedback from SE Hub")}:</span> <div className="uk-text-muted" dangerouslySetInnerHTML={{ __html: this.state.question9.feedBack.replace(/(?:\r\n|\r|\n)/g, '<br />') }}></div> </p>
                                        ) : (
                                            ""
                                        )}
                                    </div>
                                    {/* End Question 9 */}

                                    {this.state.sectionFeedBack && this.state.sectionFeedBack !== "" ? (
                                        <div
                                            href="help-post-read.html"
                                            className="uk-link-reset paper uk-margin-remove-bottom"
                                        >
                                            <h4 style={{ color: "#eaaa00", fontWeight: "bold" }}>
                                                {" "}
                                                {t("Overall section comments/feedback from SE Hub")}
                                            </h4>
                                            <div className="uk-text-muted" dangerouslySetInnerHTML={{ __html: this.state.sectionFeedBack.replace(/(?:\r\n|\r|\n)/g, '<br />') }}></div>

                                        </div>
                                    ) : (
                                        ""
                                    )}
                                    <div className="uk-margin">
                                        {(formErrorStatus.status) ? (
                                            <div className="danger_alert">{t(formErrorStatus.message)}</div>
                                        ) : ((formSuccessState.status) ? (
                                            <div className="success_alert">{t(formSuccessState.message)}</div>
                                        ) : (''))}
                                    </div>

                                    <div className="uk-text-center uk-grid uk-grid-small uk-child-width-1-6 uk-margin-small quick-nav" uk-grid>
                                        <div>
                                            <div className="uk-card">
                                                <li><a className={localStorage.RAT_LANG == "fr" ? "fr_MA_contact uk-button uk-button-default uk-button-small uk-width-1-1" : localStorage.RAT_LANG == 'ar' ? "Ar_MA_contact uk-button uk-button-default uk-button-small uk-width-1-1" : localStorage.RAT_LANG=="sp"? "uk-button uk-button-default uk-button-small uk-width-1-1 sp_MA_contact": "uk-button uk-button-default uk-button-small uk-width-1-1"} onClick={(e) => this._pagi("section1")} href="javascript:void(0)">{t("MA Contact")}</a></li>
                                            </div>
                                        </div>
                                        <div>
                                            <div className="uk-card">
                                                <li><a className="uk-button uk-button-default uk-button-small uk-width-1-1" onClick={(e) => this._pagi("section2")} href="javascript:void(0)">{t("Operations")}</a></li>
                                            </div>
                                        </div>
                                        <div>
                                            <div className="uk-card">
                                                <li><a className="uk-button uk-button-default uk-button-small uk-width-1-1" onClick={(e) => this._pagi("section3")} href="javascript:void(0)">{t("Financial")}</a></li>
                                            </div>
                                        </div>
                                        <div>
                                            <div className="uk-card">
                                                <li><a className="uk-button uk-button-default uk-button-small uk-width-1-1" onClick={(e) => this._pagi("section4")} href="javascript:void(0)">{t("HR")}</a></li>
                                            </div>
                                        </div>
                                        <div>
                                            <div className="uk-card">
                                                <li className="uk-active"><a className="uk-button uk-button-default uk-button-small uk-width-1-1" onClick={(e) => this._pagi("section5")} href="javascript:void(0)">{t("Resources")}</a></li>
                                            </div>
                                        </div>
                                        <div>
                                            <div className="uk-card">
                                                <li><a className="uk-button uk-button-default uk-button-small uk-width-1-1" onClick={(e) => this._pagi("section6")} href="javascript:void(0)">{t("Other")}</a></li>
                                            </div>
                                        </div>
                                    </div>

                                    <hr />
                                    {/* Begin Footer */}
                                    <div className="uk-grid uk-text-center button_div">
                                        <div className="uk-width-1-3@m">
                                            <Button
                                                basic
                                                className="outline-button blueButton"
                                                onClick={this._goBack}
                                            >
                                                {t("Go Back")}
                                            </Button>
                                        </div>

                                        <div className="uk-width-expand@m">

                                        </div>

                                        <div className="uk-width-1-3@m">
                                            <div>
                                                <Button
                                                    onClick={this._next}
                                                    className="next-button purpleButton"
                                                    loading={this.state.saveNContinue}
                                                    basic
                                                >
                                                    {t("Next")}
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                </Form>
                            </div>
                        </div>
                        {/* End Dark Header */}
                    </div>
                )
                }
            </div>
        );
    }
}

export default withRouter(withApollo(connect(mapStateToProps, mapDispatchToProps)(withNamespaces()(ViewSection5))));
